<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12 margin-bottom">
        <h1>Callback Management</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <b-card no-body>
          <b-tabs v-model="tabIndex" card>
            <b-tab title="calendar" @click="tabChanged">
              <b-card-text>
                <CallbackCalendar :activeTab="activeTab" @filterSearch="filterSearh" :lookups="lookups">

                </CallbackCalendar>
              </b-card-text>
            </b-tab>
            <b-tab title="search" @click="tabChanged" >
              <b-card-text>
                <CallbackSearch :newFilter="searchFilter" :lookups="lookups">

                </CallbackSearch>
              </b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>

    </div>
  </div>


</template>
<script>

  import CallbackCalendar from "@/components/admincallback/CallbackCalendar.vue";
  import CallbackSearch from "@/components/admincallback/CallbackSearch.vue";
  //import CallbackService from '@/services/Callback.service';
  import LookupsService from '@/services/Lookups.service';

  export default {
    name: "AdminCallback",
    components: {
      CallbackCalendar, CallbackSearch
    },
    data() {
      return {
        activeTab: "calendar",
        lookups: null,
        searchFilter: {
          user: null,
          priority: null,
          selectedDate: null,
        },
        tabIndex: 0,
      }
    },
    methods: {
      tabChanged(button) {
        this.activeTab = button.srcElement.innerText;
      },
      filterSearh(priority, user, date) {
        this.searchFilter.user = user;
        this.searchFilter.priority = priority;
        this.searchFilter.selectedDate = date;
        this.tabIndex = 1;
      }
    },
    created() {
      LookupsService.loadLookups().then((result) => {
        this.lookups = result.data;
        this.lookups.callbackUsers.unshift({ id: null, fullName: "-", disabled: false });
      });
    },

  }
</script>

